import { fetchHistoryReferralCompact } from '../../../../Features/Learning/Users/Utils/UserUtils';

/* **************************************************** */
/* CRUD History Daftar Referrer                         */
/* **************************************************** */

export const fetchHistoryReferralsCompacts = (dispatch, filters, refetch) => {
    dispatch(fetchHistoryReferralCompact(filters));
}

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
    if (pagination.current_page > 1) {
        dispatch(setFilters({
            ...filters,
            page: pagination.current_page - 1,
        }));
        setRefetch(prevRefetch => !prevRefetch);
    }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
    if (pagination.current_page < pagination.total) {
        dispatch(setFilters({
            ...filters,
            page: pagination.current_page + 1,
        }));
        setRefetch(prevRefetch => !prevRefetch);
    }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
    dispatch(setFilters({
        ...filters,
        page: page,
    }));
    setRefetch(prevRefetch => !prevRefetch);
}